import React, {useContext, useState} from 'react';
import {Navigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import block from 'bem-cn-lite';
import {CApi as adminGwApi} from '@services/api';
import {AppContext} from '@app/context/context';
import {Button, Modal, Text, TextInput, Switch} from '@gravity-ui/uikit';
import {tokenStorage} from '@app/storage/tokenStorage';
import {clearLogoutTimer, setLogoutTimer} from '@utils';

import './Login.scss';

const b = block('login-page');

interface LoginForm {
    login: string;
    password: string;
}

export const Login = () => {
    const appCtx = useContext(AppContext);

    const [rememberMe, setRememberMe] = useState<boolean>(true);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: {errors},
        getValues,
        setError
    } = useForm<LoginForm>({defaultValues: {login: '', password: ''}});

    if (appCtx.state.token) {
        return <Navigate to="/home" />;
    }

    const onSubmit = () => {
        setLoading(true);

        adminGwApi()
            .login.loginCreate({
                ...getValues(),
                ...{type: 'password'}
            })
            .then((r) => {
                setLoading(false);

                const token = r.data.access_token;
                const expiresAt = parseInt(r.data.expires_in, 10);
                const now = Math.floor(Date.now() / 1000);
                const timeUntilLogout = expiresAt - now;

                if (rememberMe) {
                    tokenStorage.setLocal(token);
                } else {
                    tokenStorage.setSession(token);
                }

                appCtx.emit('login', {token, rememberMe});

                // Очистка старого таймера, если он есть
                clearLogoutTimer();

                // Установка таймера на логаут
                if (timeUntilLogout > 0) {
                    console.log(`Пользователь будет разлогинен через ${timeUntilLogout} секунд`);

                    setLogoutTimer(() => {
                        appCtx.emit('logout', {redirectTo: '/'});
                    }, timeUntilLogout);
                }
            })
            .catch(() => {
                setLoading(false);
                setError('login', {message: 'Неправильный логин или пароль'});
                setError('password', {message: 'Неправильный логин или пароль'});
            });
    };

    return (
        <Modal open keepMounted className={b()}>
            <Text variant="header-2">Авторизация</Text>

            <form onSubmit={handleSubmit(onSubmit)} noValidate className={b('form')}>
                <div className={b('input')}>
                    <Text variant="body-2">Логин</Text>
                    <TextInput
                        size="xl"
                        {...register('login', {
                            required: 'Обязательно'
                        })}
                        errorMessage={errors.login && errors.login.message}
                        errorPlacement="outside"
                        validationState={errors.login && 'invalid'}
                    />
                </div>

                <div className={b('input')}>
                    <Text variant="body-2">Пароль</Text>
                    <TextInput
                        type="password"
                        size="xl"
                        {...register('password', {
                            required: 'Обязательно'
                        })}
                        errorMessage={errors.password && errors.password.message}
                        errorPlacement="outside"
                        validationState={errors.password && 'invalid'}
                    />
                </div>

                <div className={b('button-group')}>
                    <Switch
                        size="l"
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                    >
                        Запомнить меня
                    </Switch>
                    <Button type="submit" size="xl" view="action" loading={loading}>
                        Войти
                    </Button>
                </div>
            </form>
        </Modal>
    );
};
